// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__19TBm","description":"PatientConsentPreview_description__3Umuw"};